module.exports = __webpack_public_path__ + "img/P740.90bfc08b.jpg";